import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "borrow-calculator-container"
}
const _hoisted_2 = { class: "content-wr" }
const _hoisted_3 = { class: "section-buttons" }
const _hoisted_4 = {
  key: 4,
  class: "continue"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "spinner"
}
const _hoisted_7 = {
  key: 2,
  class: "budget-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "How much can I borrow?", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-info" }, "Use this borrowing power calculator to estimate how much you couldborrow and what your loan repayments will be. Just input your income and expenses and we’ll do the rest.", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: _normalizeClass(["button button-icon-primary-2 borrow-calculator", { active: $setup.activeTab === $setup.SectionTabs.ABOUT }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateActiveTab($setup.SectionTabs.ABOUT)))
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "icon user" }, null, -1),
                _createTextVNode("About you", -1)
              ]))], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["button button-icon-primary-2 borrow-calculator", { active: $setup.activeTab === $setup.SectionTabs.INCOME }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateActiveTab($setup.SectionTabs.INCOME)))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "icon income" }, null, -1),
                _createTextVNode("Your income", -1)
              ]))], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["button button-icon-primary-2 borrow-calculator expenses", { active: $setup.activeTab === $setup.SectionTabs.EXPENSES }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateActiveTab($setup.SectionTabs.EXPENSES)))
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "icon expenses" }, null, -1),
                _createTextVNode("Your expenses", -1)
              ]))], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["button button-icon-primary-2 borrow-calculator", { active: $setup.activeTab === $setup.SectionTabs.RESULT }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateActiveTab($setup.SectionTabs.RESULT)))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "icon result" }, null, -1),
                _createTextVNode("Result", -1)
              ]))], 2)
            ]),
            ($setup.activeTab === $setup.SectionTabs.ABOUT)
              ? (_openBlock(), _createBlock($setup["CalculatorAboutYouSection"], {
                  key: 0,
                  form: $setup.form,
                  formCalculatorOptions: $setup.formCalculatorOptions,
                  onUpdateForm: $setup.updateForm,
                  onUpdateFormCalculatorOptions: $setup.updateFormCalculatorOptions
                }, null, 8, ["form", "formCalculatorOptions"]))
              : _createCommentVNode("", true),
            ($setup.activeTab === $setup.SectionTabs.INCOME)
              ? (_openBlock(), _createBlock($setup["CalculatorYourIncomeSection"], {
                  key: 1,
                  form: $setup.form,
                  formCalculatorOptions: $setup.formCalculatorOptions,
                  onUpdateForm: $setup.updateForm,
                  onUpdateFormCalculatorOptions: $setup.updateFormCalculatorOptions
                }, null, 8, ["form", "formCalculatorOptions"]))
              : _createCommentVNode("", true),
            ($setup.activeTab === $setup.SectionTabs.EXPENSES)
              ? (_openBlock(), _createBlock($setup["CalculatorExpensesSection"], {
                  key: 2,
                  form: $setup.form,
                  formCalculatorOptions: $setup.formCalculatorOptions,
                  onUpdateForm: $setup.updateForm,
                  onUpdateFormCalculatorOptions: $setup.updateFormCalculatorOptions
                }, null, 8, ["form", "formCalculatorOptions"]))
              : _createCommentVNode("", true),
            ($setup.activeTab === $setup.SectionTabs.RESULT)
              ? (_openBlock(), _createBlock($setup["CalculatorResultSection"], {
                  key: 3,
                  form: $setup.form,
                  formCalculatorOptions: $setup.formCalculatorOptions,
                  onUpdateForm: $setup.updateForm,
                  onUpdateFormCalculatorOptions: $setup.updateFormCalculatorOptions,
                  onResult: $setup.handleResult
                }, null, 8, ["form", "formCalculatorOptions"]))
              : _createCommentVNode("", true),
            (!$setup.isLastTab)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["button button-icon-primary-2 borderless gray mb-small-padding", { disabled: $setup.getSectionIndex() === 1 }]),
                    onClick: $setup.backTab,
                    disabled: $setup.getSectionIndex() === 1
                  }, "Back", 10, _hoisted_5),
                  _createElementVNode("button", {
                    class: "button button-icon-primary-2 active mb-small-padding",
                    onClick: $setup.continueTab
                  }, _toDisplayString($setup.continueText), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "note" }, _toDisplayString($setup.noteText))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6)),
    ($setup.activeTab === $setup.SectionTabs.RESULT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-budget" }, "Search home designs to suit your budget:", -1)),
          _createVNode($setup["FilterHouses"], {
            result: $setup.resultCalculator,
            onHousesByFilter: $setup.housesByFilter,
            quote: $setup.quoteInfo
          }, null, 8, ["result", "quote"]),
          _createVNode($setup["ListHouses"], {
            houses: $setup.houses,
            estate: $setup.estateInfo,
            quote: $setup.quoteInfo,
            result: $setup.resultCalculator
          }, null, 8, ["houses", "estate", "quote", "result"])
        ]))
      : _createCommentVNode("", true)
  ]))
}